exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_logoNotSelected__1pxBn {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  opacity: .5;\n}\n\n.styles_logoSelected__23lZK {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n", ""]);

// Exports
exports.locals = {
	"logoNotSelected": "styles_logoNotSelected__1pxBn",
	"logoSelected": "styles_logoSelected__23lZK"
};